<script>
  import './styles/view/HowToUse.css';
  import Navigation from './components/layout/Navigation.svelte';
  
  export let user; // 사용자 정보
  export const setPage = null; // 페이지 변경 함수
  export const isAdmin = null; // 관리자 여부
  
  let activeTab = 'guide01'; // 기본 활성 탭: 회원가입
  
  function setActiveTab(tab) {
    activeTab = tab;
  }
</script>

<div class="howto-container">
  <Navigation 
    {user}
    currentPage="how-to-use"
  />

  <div class="content-container">
    <div class="tabs">
      <button 
        class="tab-btn" 
        class:active={activeTab === 'guide01'} 
        on:click={() => setActiveTab('guide01')}>
        회원 가입
      </button>
      <button 
        class="tab-btn" 
        class:active={activeTab === 'guide02'} 
        on:click={() => setActiveTab('guide02')}>
        <span>지원 방법</span>
      </button>
      <button 
        class="tab-btn" 
        class:active={activeTab === 'guide03'} 
        on:click={() => setActiveTab('guide03')}>
        진행 절차
      </button>
    </div>
    
    <div class="tab-content">
      {#if activeTab === 'guide01'}
        <div class="guide">
          <h3>간단한 회원가입으로 WIDE-WORK를 이용해 보세요.</h3>
          <p>편리한 지원이 가능합니다.</p>
          
          <div class="guide-image">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="80" height="80" fill="#3273dc">
              <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 17.93c-3.95-.49-7-3.85-7-7.93 0-.62.08-1.21.21-1.79L9 15v1c0 1.1.9 2 2 2v1.93zm6.9-2.54c-.26-.81-1-1.39-1.9-1.39h-1v-3c0-.55-.45-1-1-1H8v-2h2c.55 0 1-.45 1-1V7h2c1.1 0 2-.9 2-2v-.41c2.93 1.19 5 4.06 5 7.41 0 2.08-.8 3.97-2.1 5.39z"/>
            </svg>
          </div>
        </div>
      {:else if activeTab === 'guide02'}
        <div class="guide">
          <h3>간단한 정보 입력으로 희망하시는 업무를 지원해 보세요.</h3>
          <p>개인 이력카드로 지원자가 편리하고 간단하고 빠르게 지원할 수 있습니다.</p>
          
          <div class="guide-info">
            <h4>지원내용 입력</h4>
            <p>인터뷰 및 출근 가능일, 관련 경험 사항을 상세히 기재해 주시면 보다 효율적인 진행이 가능합니다.</p>
            <p class="highlight">* 이력카드 첨부 필수</p>
          </div>
          
          <div class="guide-image">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="80" height="80" fill="#3273dc">
              <path d="M19 3h-4.18C14.4 1.84 13.3 1 12 1c-1.3 0-2.4.84-2.82 2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 0c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm-2 14l-4-4 1.41-1.41L10 14.17l6.59-6.59L18 9l-8 8z"/>
            </svg>
          </div>
          
          <h3>원활한 진행을 위해 담당자와 다이렉트로 연결됩니다.</h3>
          <p>지원후에 담당자 검토 및 진행이 이루어지며<br>진행사항은 마이페이지-지원현황에서 확인 가능합니다.</p>
          
          <div class="guide-info">
            <h4>상세조건 협의 및 추천</h4>
            <p>필요한 경우 담당자가 연락드려 지원정보에 대해 협의한 후에<br>고객사에 추천합니다.</p>
          </div>
          
          <div class="guide-info">
            <h4>인터뷰 진행</h4>
            <p>이력서 지원 및 추천 후에 서류 합격이 되면<br>고객사와 일정을 정해 인터뷰를 진행합니다.</p>
          </div>
        </div>
      {:else if activeTab === 'guide03'}
        <div class="guide">
          <h3>인터뷰 합격이 되면<br><strong>아래의 3단계로 진행됩니다.</strong></h3>
          
          <div class="step-container">
            <div class="step-item">
              <div class="step-number">1</div>
              <div class="step-content">
                <h4>최종합격</h4>
                <p>최종합격이 되면 담당자가<br>출근공지 및 계약서류를 요청드립니다.</p>
              </div>
            </div>
            
            <div class="step-item">
              <div class="step-number">2</div>
              <div class="step-content">
                <h4>계약진행</h4>
                <p>계약서(안) 상호 확인 후 전자계약으로<br>계약을 진행합니다.</p>
              </div>
            </div>
            
            <div class="step-item">
              <div class="step-number">3</div>
              <div class="step-content">
                <h4>업무시작</h4>
                <p>업무시작 및 계약종료까지 이슈/연장/변경 등<br>지속적인 관리가 진행됩니다.</p>
              </div>
            </div>
          </div>
        </div>
      {/if}
    </div>
  </div>
  
  <footer>
    <div class="company-info">
      <h3>주식회사 비전와이드</h3>
      <p>대표자명 : 최병영 | 사업자등록번호 : 134-87-40607 | 유료직업소개사업등록번호(국내): 제2026-3900373-14-5-00003호</p>
      <p>경기도 광명시 오리로854번길 12, 3층 304호(철산동, 세인트빌딩)</p>
      <p>TEL : 02-565-5747 | FAX : 02-6499-5747 | E-mail : admin@visionwide.kr</p>
      <p>©VISIONWIDE. ALL RIGHTS RESERVED.</p>
    </div>
  </footer>
</div>
